import {
  Skeleton,
  Stack,
  SxProps,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'

export default function TableLoader({
  totalRows,
  totalColumns,
  sx
}: {
  totalRows: number
  totalColumns: number
  sx?: SxProps
}) {
  return (
    <TableContainer
      sx={{
        paddingX: '1.5rem',
        width: '100%',
        overflowX: 'auto',
        ...sx
      }}
    >
      <Table sx={{ minWidth: '37.5rem' }}>
        <TableHead>
          <TableRow>
            {Array.from({ length: totalColumns }).map((_, index) => (
              <TableCell key={index}>
                <Skeleton
                  animation='wave'
                  variant='text'
                  sx={{ height: '2rem', width: '100%', maxWidth: '8rem' }}
                />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: totalRows }).map((_, index) => (
            <TableRow key={index}>
              {Array.from({ length: totalColumns }).map((_, index) => (
                <TableCell key={index}>
                  <Stack
                    direction='row'
                    alignItems='center'
                    spacing='1rem'
                    sx={{ width: '100%' }}
                  >
                    {index === 0 && (
                      <Skeleton
                        animation='wave'
                        variant='circular'
                        sx={{ height: '2rem', width: '2rem' }}
                      />
                    )}
                    <Skeleton
                      animation='wave'
                      variant='text'
                      sx={{ height: '2rem', width: '100%', maxWidth: '14rem' }}
                    />
                  </Stack>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
